<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_6" title="Part One: Beginning a Journey">Part One<br/>
<img alt=" " src="Images/ShortLine.jpg"/><br/>
  Beginning a Journey<br/>
<br/></h2>
<p class="center"><img alt="" src="Images/7818_CHAINS.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PartOne.vue?e73ef824